import { Helmet } from "react-helmet-async";
import {
  organizationJsonLd,
  websiteJsonLd,
  professionalServiceJsonLd,
} from "@/seo/jsonLd";

/**
 * Site-wide JSON-LD: mounted once at the App root.
 * Defines the Vert AI entity, website, and professional-service node
 * that other per-page schemas reference via @id.
 */
const SiteJsonLd = () => {
  const blocks = [
    organizationJsonLd(),
    websiteJsonLd(),
    professionalServiceJsonLd(),
  ];
  return (
    <Helmet>
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default SiteJsonLd;
